var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginPageBg3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 130,
    viewBox: "0 0 289 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M317.726 410.203C422.66 394.078 509.455 423.99 577.573 344.549C619.782 295.324 641.137 252.598 633.475 188.207C621.456 87.2062 527.585 55.715 430.703 24.6508C297.58 -18.0338 175.92 -9.59716 80.436 98.3924C-15.0481 206.382 -35.5905 364.207 75.3096 434.564C155.655 485.537 237.309 422.561 317.726 410.203Z",
    fill: "#697D8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageBg3);
export default __webpack_public_path__ + "static/media/loginPageBg_3.e79b61eec0755b83bb2b9364e15abb30.svg";
export { ForwardRef as ReactComponent };